import script from "./AddCensus.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCensus.vue?vue&type=script&setup=true&lang=js"

import "./AddCensus.vue?vue&type=style&index=0&id=f1569dc8&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1569dc8"]])

export default __exports__